import { Container, Divider, Spacer } from '@cleartrip/ct-design-components'
import { Stencil } from '@/components/common/Stencil'
import React, { memo } from 'react'

const LoaderSegment = memo(() => (
    <Container className="flex flex-between">
        <Container className="o-hidden">
            <Stencil shimmer height="20px" width="150px" className="br-2" />
        </Container>
        <Container className="pl-6 flex flex-column flex-between">
            <Container className="flex flex-baseline flex-right mb-1">
                <Stencil shimmer height="24px" width="69px" className="br-2" />
            </Container>
            <Stencil shimmer height="14px" width="43px" className="br-2" />
        </Container>
    </Container>
))

const LoaderCard = memo(() => (
    <Container className="mb-4">
        <Container className="br-16 pt-4 w-100p ba-solid" css={{ borderColor: '#e6e6e6' }}>
            <Container className="flex flex-between px-4">
                <Container className="flex flex-middle">
                    <Container>
                        <Stencil shimmer height="32px" width="32px" className="br-8" />
                    </Container>
                    <Spacer className="ml-2" />
                    <Container>
                        <Stencil shimmer height="14px" width="62px" className="br-2" />
                        <Spacer className="mb-1" />
                        <Stencil shimmer height="14px" width="62px" className="br-2" />
                    </Container>
                </Container>
                <Container width="120px" className="ml-12 pl-13">
                    <Stencil shimmer height="40px" width="120px" className="br-2" />
                </Container>
            </Container>
            <Container className="mt-3 mb-3 px-4">
                <Stencil shimmer height="20px" width="88px" className="br-2" />
            </Container>
            <Divider />
            <Container className="px-4 py-3" css={{ borderBottomLeftRadius: '15px', borderBottomRightRadius: '15px' }}>
                <LoaderSegment />
                <Container className="px-2 my-3">
                    <Divider borderColor="#E6E6E6" borderStyle="dotted" />
                </Container>
                <LoaderSegment />
            </Container>
        </Container>
        <Container
            backgroundColor="#F3F3F3"
            className="h-8 mx-4 flex flex-center flex-middle"
            css={{ borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}
        >
            <Stencil shimmer height="16px" width="134px" className="br-8" />
        </Container>
    </Container>
))

function OnewayTuppleLoader() {
    return (
        <Container className="mt-6">
            <LoaderCard />
            <LoaderCard />
        </Container>
    )
}

export default OnewayTuppleLoader
